// extracted by mini-css-extract-plugin
export default {"wrap":"rightSlide_wrap__yzHKw","active":"rightSlide_active__s2-tF","container":"rightSlide_container__+LD9z"};